module.exports = __webpack_public_path__ + "static/fish-7b0a4fc59ee85120fc6821d39a413471.jpg";